import { Col } from '@opendoor/atoms/box';
import { determinePropertyActionability } from 'components/marketplace/helpers/propertyActionability';

import { BuyDirectCTA } from '../BuyDirectCTA';
import { BuyWithConfidence } from '../BuyWithConfidence';
import type { PropertyDetailsType } from '../types';

interface PropertyCTAsProps {
  property: PropertyDetailsType;
}

export const PropertyCTAs = ({ property }: PropertyCTAsProps) => {
  const { isActionable, tourKind } = determinePropertyActionability(property);

  if (!isActionable || !tourKind) {
    return null;
  }

  return (
    <Col className="gap-12 px-0 pt-12">
      <BuyDirectCTA property={property} />
      {property.shouldShowGuarantee && <BuyWithConfidence />}
    </Col>
  );
};
